<template>
  <div  class="container-fluid cienheight">
    <div class="row">
      <div class="col-6 m-auto">
        <b-form @submit.prevent="onSubmit" @reset="onReset" v-if="show">
          <b-form-group
            id="input-group-2"
            label="Para acceder a la carga de buró: "
            label-for="input-2"
          >
            <b-form-input
              type="password"
              id="input-2"
              v-model="form.password"
              required
              placeholder="Ingresa el password"
            ></b-form-input>
          </b-form-group>

          <b-button type="submit" variant="primary">Submit</b-button>
          <b-button class="mx-5" type="reset" variant="danger">Reset</b-button>
        </b-form>
        <div class="row my-1">
          <div class="col-12 my-1 text-center">
            <!-- PARA GUARDAR EL ROOT EN BASE DE DATOS -->
            <b-button class="mr-2" @click="regresaAHome" variant="warning">Volver a la revista</b-button>
          </div>
        </div>
      </div>
    </div>
    <div class="row my-5" v-if="showUpload">
      <div class="col-12">
        <div class="container">
          <!-- <div class="row my-1">
            <div class="col-12">
              <label for="example-datepicker">Eligue la fecha de la revista.</label>
              <small>
                <b>Recuerda que la fecha es obligatoria.</b>
              </small>
              <b-form-datepicker id="example-datepicker" v-model="fecha" class="mb-2"></b-form-datepicker>
              <p>Value: '{{ fecha }}'</p>
            </div>
          </div>-->
          <div class="row my-3">
            <!--  PARA SUBIR UN ROOT-FILE DESDE LOCAL -->
            <div class="col-12">
              <b-form-file
                v-model="loadroot"
                :state="Boolean(loadroot)"
                :file-name-formatter="setRootLocal"
                placeholder="Selecciona un RootFile o suelta uno aquí."
                drop-placeholder="Drop file here..."
                browse-text="Buscar"
              ></b-form-file>
              <div class="mt-3">
                <b>Archivo seleccionado</b>
                : {{ loadroot ? loadroot.name : '' }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 my-5">
              <!-- PARA GUARDAR EL ROOT EN BASE DE DATOS -->
              <b-button class="mr-2" @click="storeInDB" variant="primary">
                Guardar Revista en
                <b>base de datos</b> Buró.
              </b-button>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-12">
              <p class="h2">Insertar id de esta revista en base de datos.</p>
              <small>
                Recuerda que esto solo debe hacerse una vez al mes, al inicio
                del desarrollo de la revista.
              </small>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-12">
              <div @click="insertaid" class="btn btn-primary">Insertar ID</div>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-12">
              <p class="h2">Insertar las secciones de la revista en base de datos</p>
              <small>
                Recuerda que este proceso solo se realiza cuando se ha terminado
                de diseñar por completo la revista.
              </small>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-12">
              <div @click="insertarSecciones" class="btn btn-primary">Insertar secciones</div>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-12">
              <p class="h2">
                <b>Consultar estádisticas y ganadores de la trivia.</b>
              </p>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-3">
              <!-- meses que tienen registro de revistas -->
              <label for="meses">Selecciona el mes:</label>
              <br />
              <select v-model="mes" id="meses">
                <option v-for="(mes, index) in meses" :key="index" :value="mes">{{ mes }}</option>
              </select>
            </div>
            <div class="col-3">
              <!-- años que tienen registro de revistas -->
              <label for="years">Selecciona el año:</label>
              <br />
              <select v-model="year" id="years">
                <option v-for="(year, index) in years" :key="index" :value="year">{{ year }}</option>
              </select>
            </div>
            <div class="col-3">
              <label for="pass">Ingresa el password para ver las estadisticas</label>
              <input id="pass" type="password" v-model="pass" />
            </div>
            <div class="col-3">
              <div @click="muestraStats" class="btn btn-primary">Revisar Stats</div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <p class="h2">
                Visitas de esta revista:
                <b>{{ this.visitas }}</b>
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-4">
              <p class="text-bold h5">Nombre de la seccion:</p>
              <ul>
                <li v-for="(name, index) in names" :key="index">{{ name }}</li>
              </ul>
            </div>
            <div class="col-4">
              <p class="text-bold h5">Número de lecturas:</p>
              <ul>
                <li v-for="(lectura, index) in lecturas" :key="index">{{ lectura }}</li>
              </ul>
            </div>
            <div class="col-4">
              <p class="text-bold h5">Número de likes:</p>
              <ul>
                <li v-for="(like, index) in likes" :key="index">{{ like }}</li>
              </ul>
            </div>
          </div>
          <div class="ganadores-list">
            <div class="row my-5">
              <div class="col-12">
                <p class="text-bold h4">Ganadores de la trivia de esta revista</p>
              </div>
            </div>
            <div class="row my-3 " v-for="(ganador, index) in ganadores" :key="index">
              <div class="col-6">{{ ganador.nombre }}</div>
              <div class="col-6">{{ ganador.area }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'buro',
  data() {
    return {
      ganadores: [],
      meses: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      years: [2020, 2021, 2022, 2023, 2024, 2025, 2026, 2027],
      visitas: 0,
      lecturas: [],
      names: [],
      likes: [],
      sections: [],
      loadroot: null,
      showUpload: false,
      show: true,
      // fecha: '',
      form: {
        password: ''
      },
      mes: null,
      year: null,
      fecha: null,
      pass: null,
      tempRoot: null,
      id_revista: null
    }
  },
  /*created() {
    this.tempRoot = JSON.parse(window.localStorage.getItem('root'))
    this.id_revista = tempRoot['detalles'][0]['num']
    this.fecha = tempRoot['detalles'][0]['fecha']
    let dated = this.fecha.split('-')
    this.mes = dated[1]
    this.year = dated[0]

  },*/
  methods: {
    muestraStats() {
      if (!this.pass === 'muchachos') {
        return
      }

      this.likes = []
      this.lecturas = []
      this.names = []
      this.ganadores = []
      this.visitas = 0
      
      console.log(this.mes)
      console.log(this.year)
      console.log(this.pass)
      axios
        .post('muestra_stats.php', {
          mes: this.mes,
          year: this.year,
          pass: this.pass
        })
        .then(resp => {
          console.log(resp.data.respuesta)
          let stats = resp.data.respuesta
          stats.forEach(element => {
            this.visitas = element.visitas
            this.names.push(element.nombre)
            this.lecturas.push(element.lecturas)
            this.likes.push(element.likes)
          })
        })
        .catch(Error => {
          console.log(Error)
        })
      axios
        .post('get_ganadores.php', { year: this.year, mes: this.mes })
        .then(resp => {
          console.log(resp.data.ganadores)
          let myResp = resp.data.ganadores
          myResp.forEach(element => {
            let winnerObj = {}
            winnerObj.nombre = element.nombre
            winnerObj.area = element.area
            this.ganadores.push(winnerObj)
          })
        })
    },

    insertaid() {
      this.tempRoot = JSON.parse(window.localStorage.getItem('root'))
      this.id_revista = this.tempRoot['detalles'][0]['num']
      this.fecha = this.tempRoot['detalles'][0]['fecha']
      let dated = this.fecha.split('-')
      this.mes = dated[1]
      this.year = dated[0]

      axios
        .post('crea_revista.php', {
          fecha: this.fecha,
          year: this.year,
          month: this.mes
        })
        .then(resp => {
          console.log(resp.data)
        })
        .catch(Error => {
          console.log(Error)
        })
    },

    regresaAHome() {
      this.$router.push('/')
    },
    onSubmit() {
      if (this.form.password === 'ornamental32') {
        this.show = false
        this.showUpload = true
      } else {
        alert('Credenciales erróneas')
        return
      }
    },

    onReset(evt) {
      evt.preventDefault()
      // Reset our form values
      this.form.name = ''
      this.form.password = ''
      // Trick to reset/clear native browser form validation state
      this.show = false
      this.$nextTick(() => {
        this.show = true
      })
    },

    setRootLocal() {
      this.$loading(true)
      console.log('fired')

      let fr = new FileReader()
      fr.onload = () => {
        if (fr.result) {
          this.uploadedRoot = JSON.parse(fr.result)
          console.log(this.uploadedRoot)
          window.localStorage.setItem('root', JSON.stringify(this.uploadedRoot))
          this.$loading(false)
          alert('Se ha cargado con éxito la revista de forma local')
          0
        } else {
          this.$loading(false)
          alert('Ha ocurrido un error, intenta de nuevo.')
        }
      }
      fr.readAsText(this.loadroot)
    },

    getCurrentDate() {
      let date = new Date()
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      let fullDate = year + '-' + month + '-' + day
      return fullDate
    },

    storeInDB() {
      // if (this.fecha === null || this.fecha === '') return
      this.$loading(true)

      let tempRoot = JSON.parse(window.localStorage.getItem('root'))
      let tempRoot2 = window.localStorage.getItem('root')
      let id_revista = tempRoot['detalles'][0]['num']
      console.log('id', id_revista)
      // let dateObj = new Date()
      let localfecha = tempRoot['detalles'][0]['fecha']
  console.log('fecha', localfecha)
     axios
        .post('inserta_root.php', {
          root: tempRoot2,
          fecha: localfecha,
          id: id_revista
        })
        .then(resp => {
          this.$loading(false)
          if (resp.data) alert('Insertado con éxito!')
          if (!resp.data) alert('Error en la conexión.')
        })
        .catch(Error => {
          this.$loading(false)
          if (Error) alert('No pudo guardarse la revista')
        })
    },

    insertarSecciones() {
       this.tempRoot = JSON.parse(window.localStorage.getItem('root'))
        this.id_revista = this.tempRoot['detalles'][0]['num']
        this.fecha = this.tempRoot['detalles'][0]['fecha']
        let dated = this.fecha.split('-')
        this.mes = dated[1]
        this.year = dated[0]

      this.localRoot = JSON.parse(window.localStorage.getItem('root'))
      this.sections = this.localRoot['componentes']['secciones']

      let info_sections = []

      Object.values(this.sections).forEach(element => {
        const obj = {}
        obj.nombre = element.id
        obj.titulo = element.titulo
        info_sections.push(obj)
      })

      axios
        .post('inserta_secciones.php', {
          sections: info_sections,
          mes: this.mes,
          year: this.year
        })
        .then(resp => {
          console.log(resp.data)
        })
        .catch(Error => {
          console.log(Error)
        })
    }
  }
}
</script>

<style scoped>
.cienheight {
  min-height: 100vh !important;
  overflow-x: hidden;
}

li {
  list-style: none !important;
}

.ganadores-list {
  margin-bottom: 200px;
}
</style>
